import React from "react"

export const purpleFibreQuestions = [
  {
    id: 1,
    question: "What is Purple Fibre?",
    answer: (
      <span>
        Purple Fibre is Canada’s fastest and most reliable fibre internet. Built
        from the ground up by Purple Cow, we own everything—from our servers to
        your home—allowing us to deliver speeds 10x faster than the big guys,
        with the lowest ping rates, all at the best price.
      </span>
    ),
  },
  {
    id: 2,
    question:
      "Are the install appointments a window of time or an exact appointment time?",
    answer: (
      <span>
        We value your time just like we value our own, so all Purple Fibre
        appointments are scheduled for an exact time. You’ll never have to wait
        around for hours wondering when our team will arrive.
      </span>
    ),
  },
  {
    id: 3,
    question: "How long does it take to get set up with Purple Fibre?",
    answer: (
      <span>
        Our goal is to have you online the same day you order. While this isn’t
        always possible, when you order Purple Fibre online, you can select the
        exact date and time for your installation.
      </span>
    ),
  },
  {
    id: 4,
    question: "Will I have internet when my power goes out?",
    answer: (
      <span>
        We built our network so that if you lose power—but have a home generator
        running—your internet will continue to work
      </span>
    ),
  },
  {
    id: 5,
    question: "Whose network do you use?",
    answer: (
      <span>
        We built our own network from the ground up. The entire infrastructure
        is owned and operated by Purple Cow, which is why we can offer speeds
        10x faster than the big guys—all while delivering the best customer
        service.
      </span>
    ),
  },
  {
    id: 6,
    question: "Do you have your own technicians, or do you subcontract?",
    answer: (
      <span>
        We have the coolest techs in the coolest vehicles! Ask them to show you
        the vehicles mooing! Our techs work directly for Purple Cow, ensuring
        they show up on time and get you connected quickly and professionally.
      </span>
    ),
  },
  {
    id: 7,
    question: "Do I have to install the internet myself?",
    answer: (
      <span>
        Nope! We provide Purple Glove Service—handling everything for you so you
        can enjoy a smooth, hassle-free transition.
      </span>
    ),
  },
  {
    id: 8,
    question: "What happens if Purple Fibre is not available in my area?",
    answer: (
      <span>
        If we haven’t reached your area yet, you can provide your info {""}
        <a
          target="_blank"
          className="text-blue-600 underline"
          href="https://www.purplecowinternet.com/purplefibre/waiting-list/"
        >
          HERE
        </a>
        , and we’ll contact you when it becomes available. If there’s strong
        demand in a certain area, we’ll prioritize bringing Purple Fibre there
        sooner.
      </span>
    ),
  },
]

export const eastLinkQuestions = [
  {
    id: 1,
    question: "How long does it take to get turned on?",
    answer:
      "Usually everything is complete within 3-4 business days unless a tech is required. We use local technicians to your area so depending on availability if a tech is required it can take a little longer. Normally a tech is only required if you are in a new construction or if you know there is no coax in your home.",
  },
  {
    id: 2,
    question: "Will the Wifi get everywhere in my home?",
    answer:
      "We provide a Wifi router for free with your system. The router is awesome and sends out both 5G and 2.4G wifi. If you are having trouble getting the wifi all around your home there are several trouble shooting steps we can work with you on to make sure it works great in your home.",
  },
  {
    id: 3,
    question: "Can I adjust my packages?",
    answer:
      "Super easy to adjust your package. Just shoot us a text and we will make any changes you like.",
  },
  {
    id: 4,
    question: "Do I need the Gig internet plan?",
    answer:
      "Every herd member is different however most of the time the Gig plan provides more bandwidth than you need. We always suggest starting on a lower package and working your way up if needed.",
  },
  {
    id: 5,
    question: "With prices starting at $60 is the internet any good?",
    answer:
      "Our Internet is great. Check out our google reviews if you don't believe us. It is the same internet as the big guys only less expensive.",
  },
]

export const homePhoneQuestions = [
  {
    id: 1,
    question: "What are all the features included?",
    answer: (
      <>
        This whole list is free and included:
        <table>
          <tbody>
            <tr>
              <th>Title</th>
              <th>Description</th>
            </tr>
            <tr>
              <td>Voicemail</td>
              <td>
                A voicemail box was assigned to you with your service. In the
                Voice Portal, you can upload your voicemail greetings and
                personal name recordings, view and manage any saved messages,
                and set up voicemail forwarding to email.
              </td>
            </tr>
            <tr>
              <td>Caller ID </td>
              <td>
                The name sent with caller ID, sometimes referred to as CNAM, is
                a setting on your phone number.{" "}
              </td>
            </tr>
            <tr>
              <td>Call History</td>
              <td>
                Call History holds the records of all calls made and received on
                the account.
              </td>
            </tr>
            <tr>
              <td>Do Not Disturb </td>
              <td>
                When you don’t want your phone to ring, activate Do Not Disturb
                to send all incoming calls directly to your voicemail box.
              </td>
            </tr>
            <tr>
              <td>Last Call Return</td>
              <td>
                Three-way calling lets you bring two parties into the same call
                so all may participate in the same conversation.
              </td>
            </tr>
            <tr>
              <td>Voicemail Local Access</td>
              <td>
                Your voicemail box can be accessed in the Voice Portal,
                remotely, or by dialing a star code from a phone connected to
                the account.
              </td>
            </tr>
            <tr>
              <td>Three-way Calling</td>
              <td>
                Three-Way Calling lets you talk with two people in two different
                locations, at the same time, or talk privately with one party
                while the other holds.
              </td>
            </tr>
            <tr>
              <td>Call Handling</td>
              <td>
                Call Handling determines how your incoming calls will be routed
                under different circumstances.
              </td>
            </tr>
            <tr>
              <td>Call Screening</td>
              <td>
                You have control to ensure you receive important calls. You can
                limit the callers that ring your phone, filter callers, or
                forward important callers to another number.
              </td>
            </tr>
            <tr>
              <td>Anonymous Callers</td>
              <td>
                Calls from anonymous callers (those without caller ID) can waste
                your time and distract you from other calls you want to take.
                Block them from even ringing your phone.
              </td>
            </tr>
            <tr>
              <td>Custom Callers </td>
              <td>
                Use this feature to control who can call your phone and what
                happens when they do. These settings can be managed in the Voice
                Portal or by star code.
              </td>
            </tr>
            <tr>
              <td>Robocall Blocking</td>
              <td>
                Block the telephone numbers of known telemarketers and
                robocallers.
              </td>
            </tr>
            <tr>
              <td>Sim Ring</td>
              <td>
                Enables a call to ring to multiple lines and/or phone numbers
                simultaneously.
              </td>
            </tr>
            <tr>
              <td>Call Trace</td>
              <td>
                Call Trace allows you to mark a harassing or threatening phone
                call in your Call History.
              </td>
            </tr>
            <tr>
              <td>Call Forwarding</td>
              <td>
                When you aren’t available to answer calls on your phone, you can
                forward your calls somewhere else. Call Forwarding can be set up
                in the voice portal or by star codes. In the Voice Portal, you
                can set up a schedule to forward calls during certain hours,
                like your lunch break.
              </td>
            </tr>
            <tr>
              <td>Remote Access Forwarding</td>
              <td>
                When you’re away from your phone but still want to receive
                calls, you don’t need to get back to your phone to set things
                up. Unconditional call forwarding, or forwarding of all calls,
                is available remotely using the voicemail system, so it will
                continue to function even if there is a power outage, internet
                outage, or device failure.
              </td>
            </tr>
            <tr>
              <td>Call Waiting</td>
              <td>
                {" "}
                With Call Waiting, you can see who is calling, even if you’re on
                another call (as long as caller ID is supported on your phone).
                If a second call comes in while you’re on a call, you’ll hear
                the Call Waiting tone. To answer that call, you can choose to
                place your current call on hold and pick up the incoming call.
                Additionally, you can temporarily or completely enable or
                disable Call Waiting from your phone or in the Voice Portal.
              </td>
            </tr>
            <tr>
              <td>Collect Calls</td>
              <td> Collect calls are currently not offered.</td>
            </tr>
          </tbody>
        </table>
      </>
    ),
  },
  {
    id: 2,
    question: "What would be long distance calling?",
    answer: (
      <p>
        Call anywhere across Canada and the US (excluding Hawaii and Alaska)
        free of charge. For calling outside of Canada and the US, we recommend
        you use an online service like Whatsapp or Skype to avoid expensive long
        distance charges. To keep our phone service at the lowest cost to you
        and to prevent any surprises we do not offer any long distance in our
        plans.
      </p>
    ),
  },
  {
    id: 3,
    question: "Can I get a new number?",
    answer: <p>Yup. We can provide you a new number free of charge.</p>,
  },
  {
    id: 4,
    question: "Can I use my existing phone number?",
    answer: (
      <p>
        Yup. You can keep your current phone number and we will take care of
        porting it over to our service for you.
      </p>
    ),
  },
  {
    id: 5,
    question: "How long does it take to port my current home phone number?",
    answer: (
      <p>
        Normally takes about a week. During this week you will not lose access
        to your current phone. Once it switches it is automatic and can then
        plug in your Purple Cow phone box.
      </p>
    ),
  },
  {
    id: 6,
    question: "Is a phone handset included in this as well?",
    answer: (
      <p>
        What we provide is a box for your handset to plug into. We do not supply
        the handset however the box will work with all existing phones.
      </p>
    ),
  },
  {
    id: 7,
    question: "What is the difference between VOIP and Landline?",
    answer: (
      <p>
        VOIP (Voice over Internet Protocol) uses the internet to transmit voice
        data digitally, offering flexibility and cost-effectiveness for voice
        communication on various devices. It relies on internet connectivity,
        which may affect call quality. In contrast, Landline uses traditional
        copper wires for analog voice transmission, providing stable call
        quality and reliability, even during power outages. Landlines are fixed
        to specific geographical locations, while VOIP enables communication
        from any internet-connected place. VOIP typically offers advanced
        features like video conferencing, while Landlines may have limited
        features. The choice depends on factors such as cost, mobility, call
        quality, and the need for additional functionalities.
      </p>
    ),
  },
  {
    id: 8,
    question:
      "What are the star codes for voice mail, return missed call and others?",
    answer: (
      <p>
        You can find the full list here:{" "}
        <a
          href="https://purplecowinternet.com/home-phone/star-codes/"
          style={{ color: "purple" }}
        >
          STAR CODES
        </a>
      </p>
    ),
  },
]

export const homePageQuestions = [
  {
    id: 1,
    question: "When I switch to Purple Cow will my internet quality decrease?",
    answer:
      "Not at all. It is the same internet as the big guys. Our internet is awesome and we have tens of thousands of herd members to prove it.",
  },
  {
    id: 2,
    question:
      "How is it possible that Purple Cow Internet is so much less expensive?",
    answer:
      "Purple Cow Internet's goal is to drive down the cost of internet so we look for efficiencies where we can to make this happen.",
  },
  {
    id: 3,
    question: "Is Purple Cow Internet's service reliable?",
    answer:
      "Very much so. We have invested into state of the art equipment and double up on everything within our data centers to ensure redundancy. We have a 99.999% up time and will continue to invest into our equipment to make sure you have the best wifi experience.",
  },
  {
    id: 4,
    question: "Does Purple Cow have a referral program?",
    answer:
      "Totally! Any friend you refer you receive $25 and they get $15. Once your internet is live you will receive a link that can be shared with friends and family. All they do is just signup as normal with your link and both of you will get the credit.",
  },
  {
    id: 5,
    question: "How does billing work?",
    answer:
      "Billing is done on a credit card or visa debit card just like Netflix or other subscription sites. When you signup a charge is made on your card for the first month and setup. The date your internet turns on becomes your monthly bill date.",
  },
  {
    id: 6,
    question: "Do I need to cancel with my other provider?",
    answer:
      "Yes, once you have the cow’s internet setup you will cancel with your other provider.",
  },
]

export const tvQuestions = [
  {
    id: 1,
    question: <> Can I download the Purple Cow TV app on a Roku?</>,
    answer: (
      <>
        No, we currently do not support Roku. Our team is very familiar with
        Firesticks, and we recommend using them. The cost of a Firestick is only
        $39, and you can purchase one from this link:
        <br></br> <br></br>{" "}
        <a
          href="https://www.amazon.ca/amazon-fire-tv-stick-hd/dp/B0CQN248PX/ref=sr_1_1?crid=1PI90734H8JUN&dib=eyJ2IjoiMSJ9.T81LDK4RtHVKEcNveCir3p6Dcf6AV0lzCqvyC8sYfKpu4JCMMs53LD2Juq-cb_JWkPraJXiyQjIb-ycHrJNcXvYXiT96WVA24T0B756iITHGi0zbO-n-IE-wAwiyjaNxsGRrDyzaqZnaMbxxPk8sz2MkzC1BcJ4r3vT9Lm56ZIpZNxvv54JsQZ4rWniFHoQKSuq_3HTa3NT3EUPi94mpQbV_lgbfhJAe7lSMiXO4RCN_DPcneRzbx9kz7QyD6OXROFY7ED1KL1267I5Vtin7pzkpvJch0TY5c5f4FrLI1QB4pbDNP1xEJcI9N39F6-vbTnHODIg_l1E3q4LMP0gWc1Z2G5W0I4s5n0G5aCQ4j3U0WFD-iDXcOP4lH4KgRPQUw87VidjK9B6Un8tTgPyOBdb6dKAsb7uAoOo2vSrmSCO_A8t9nDBr5JpimGdmhz1a.WYc4mWkx0AA5Eb5-6GsZ6yuZd0WrgzmXMbjpibFp2DU&dib_tag=se&keywords=firestick&qid=1736724576&sprefix=firestick%2Caps%2C121&sr=8-1"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          Buy Amazon Firestick
        </a>
        .
      </>
    ),
  },
  {
    id: 2,
    question: <> Do you guys send me a TV box or can I just use my own?</>,
    answer: (
      <>
        With Purple Cow TV you can use your existing streaming devices including
        any Apple, Android, Google or firestick device and soon just in your
        computer browser. We do not provide a TV box or any other streaming
        boxes. If you currently do not have one we recommend going with an
        Amazon Firestick. Solid device and only costs around $40. Note:
        Compatibility with version 5.x FireOS has been discontinued.
      </>
    ),
  },
  {
    id: 7,
    question: <> How do I setup my Fire Stick?</>,
    answer: (
      <>
        <div>
          <iframe
            className="rounded-3xl w-full"
            height="630"
            src="https://www.youtube.com/embed/9NAMjKYUhxU?si=WVrw36Ug_MJPa2gS"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
        <br></br>
        For step by step instructions please
        <a
          href="https://purplecowinternet.com/tv/channel-guide/"
          style={{ color: "purple" }}
        >
          {" "}
          CLICK HERE
        </a>
      </>
    ),
  },
  {
    id: 3,
    question: <> What is the full list of approved devices?</>,
    answer: (
      <>
        <p>
          <strong>Apple TV</strong>
        </p>
        <li>tvOS 15 or later</li>
        <br></br>
        <strong>iOS Mobile</strong>
        <li>iOS 15 or later</li>
        <br></br>
        <strong>Android Mobile</strong>
        <li>7.0 or later</li>
        <br></br>
        <strong>Android TV</strong>
        <li>
          Minimum OS supported is Android/Google TV 9.0 or higher (do not
          support android mobile release on STB)
        </li>
        <br></br>
        <strong>Google TV</strong>
        <li>All versions</li>
        <br></br>
        <strong>Fire TV (FireOS version must 6 or later)</strong>
        <li>Fire TV (Gen 1) - AFTB (released April 12, 2014))</li>
        <li>Fire TV Stick (Gen 1) - AFTM - (released Nov 19, 2014)</li>
        <li>Fire TV (Gen 2) - AFTS - (released Sep 29, 2015)</li>
        <li>Fire TV Stick (Gen 2) - AFTT (released Oct 20, 2016)</li>
        <li>Fire TV Edition - Element 4K (2017) - AFTRS</li>
      </>
    ),
  },
  {
    id: 4,
    question: <> How many devices can watch TV at once?</>,
    answer: (
      <>
        {" "}
        You can have up to 15 unique devices connected to the service, with 5
        devices all watching at once.
      </>
    ),
  },
  {
    id: 5,
    question: <> Can I add other channels?</>,
    answer: (
      <>
        {" "}
        Yes, for sure. You can pretty much add anything you want to the Local
        News package. Also if you want to add a channel we currently do not have
        in our packages let us know and we will see if we can get it for you.
      </>
    ),
  },
  {
    id: 6,
    question: <> Is there DVR?</>,
    answer: (
      <>
        {" "}
        Yup! DVR is available. Add 50 hours of recording time for only $5/month.
        You can record unlimited channels at the same time with all your
        recordings saved for 6 months.{" "}
        <p>
          The coolest thing about the DVR is that all your recordings are
          available on all your devices.
        </p>
      </>
    ),
  },
  {
    id: 8,
    question: <> What is the complete channel list and guide?</>,
    answer: (
      <>
        {" "}
        <p>
          A complete channel guide:{" "}
          <a
            href="https://purplecowinternet.com/tv/channel-guide/"
            style={{ color: "purple" }}
          >
            CHANNEL GUIDE
          </a>
        </p>
      </>
    ),
  },
]

export const neighborInNeedQuestions = [
  {
    id: 1,
    question: "What is Purple Cow's Neighbor in Need program?",
    answer: (
      <div>
        <div>
          We understand that life can throw challenges your way, and at Purple
          Cow, we believe in lifting up our herd. That’s why we’re rolling out
          the Neighbor in Need program, where our community can come together to
          make a real difference. We’re inviting members to donate just $2 a
          month, and Purple Cow will match each contribution, dollar for dollar.
        </div>
        <div className="mt-4">
          These funds will go straight to helping our neighbors stay connected
          when times are tough, keeping their internet running so they can find
          their footing and get back on track. Because at Purple Cow, we’re more
          than just an internet provider—we’re a family that’s here to support
          each other, no matter what.
        </div>
        <div className="mt-4">
          To launch the Neighbor in Need program, Purple Cow is proud to take
          the first step by contributing an initial $10,000 to the fund. This
          kickstart ensures that we can immediately begin supporting our
          neighbors who need help staying connected. We’re excited to see the
          herd rally together and grow this fund, so we can help even more of
          our community get back on their hooves. Together, we’re making a
          difference—let’s go!
        </div>
      </div>
    ),
  },
  {
    id: 2,
    question: "Supporting the Neighbor in Need program is simple!",
    answer:
      "Just add $2 to your monthly renewal right through your account, and your contribution will go directly into a fund to help keep our neighbors connected. If you’d prefer to make a one-time donation, just send us a message or give us a call at 1-902-800-2660. Every little bit helps, and when the herd comes together, we make a big impact. Let’s keep our community strong, connected, and moving forward—together!",
  },
  {
    id: 3,
    question: "How are the Neighbor in Need funds used?",
    answer: (
      <div>
        <div>
          Every dollar raised through the Neighbor in Need program goes directly
          to covering internet bills for customers facing tough times, as well
          as supporting vulnerable groups across the Maritimes—including
          low-income parents, the elderly, and the homeless. We know it’s not
          always easy out there, and our goal is to lend a helping hand to keep
          everyone connected.
        </div>
        <div className="mt-4">
          To ensure the program stays fair and sustainable, we’ve put measures
          in place to prevent misuse, so the funds reach those who truly need
          support. By coming together as a herd, we can make sure our community
          continues to thrive, one connection at a time.
        </div>
      </div>
    ),
  },
  {
    id: 4,
    question: "Why we started the Neighbor in Need program",
    answer:
      "Lately, we’ve been hearing from the herd about job losses, unexpected expenses, and other financial hurdles that make it tough to stay on top of bills. At Purple Cow, we’re grateful for the strong community support we’ve received, and we believe in giving back when our neighbors are in need. That’s why we created the Neighbor in Need program—because when the herd helps the herd, no one gets left behind. We’re here to ensure that our community stays connected, even in tough times. Together, we can make a real difference.",
  },
]
